export const THEME_MEDIA = {
  nonMobileForHeader: 1328,
  mobileForHeader: 1327,
};

const theme = Object.freeze({
  colors: {
    heroBg: " #fc714a",
    blurBg: " #ffab95",
    orange: "#FF6030",
  },
  fonts: {
    primary: '"Switzer", sans-serif',
    primaryRoboto: '"Roboto", sans-serif',
  },
  media: {
    nonMobileForHeader: `(min-width: ${THEME_MEDIA.nonMobileForHeader}px)`,
    mobileForHeader: `(max-width: ${THEME_MEDIA.mobileForHeader}px)`,
    nonMobile: "(min-width: 769px)",
    mobile: "(max-width: 768px)", // src/lib/constants.js > MOBILE_BREAKPOINT
    nonTablet: "(min-width: 1201px)",
    tablet: "(max-width: 1200px)", // src/lib/constants.js > TABLET_BREAKPOINT
  },
});

export default theme;
